import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import styles from './empty-basket-notification.scss';

export default class EmptyBasketNotification extends PureComponent {
  static propTypes = {
    handleButtonClick: PropTypes.func,
  };

  static defaultProps = {
    handleButtonClick: window.defaultFunc,
  };

  render() {
    const { handleButtonClick } = this.props;

    return (
      <div className={styles.container} data-test="empty-basket-notification-container">
        <h2 className={styles.title}>Your basket is empty</h2>

        <PrimaryButton
          className={styles.button}
          onClick={handleButtonClick}
        >
          Return to homepage
        </PrimaryButton>
      </div>
    );
  }
}
